'use client';

import { useState } from 'react';
import { useAdBlock } from '@/contexts/AdBlockContext';
import { useI18n } from '@/lib/i18n/context';

export function AdBlockBanner() {
  const { hasAdBlock, checked } = useAdBlock();
  const [dismissed, setDismissed] = useState(false);
  const { t } = useI18n();

  if (!checked || !hasAdBlock || dismissed) return null;

  return (
    <div className="fixed top-20 left-0 right-0 z-50 bg-amber-950 border-t border-amber-700/60 shadow-2xl">
      <div className="max-w-screen-xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
        {/* Text */}
        <div className="flex items-center gap-3">
          <span className="text-2xl shrink-0">🙏</span>
          <div>
            <p className="font-semibold text-amber-200 text-sm">
              {t.adsblock.title}
            </p>
            <p className="text-amber-400/80 text-xs">
              {t.adsblock.description}
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 shrink-0 pl-11 sm:pl-0">
          <button
            onClick={() => window.location.reload()}
            className="bg-amber-500 hover:bg-amber-400 text-white text-xs font-semibold px-4 py-2 rounded-xl transition-colors"
          >
            {t.adsblock.action}
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="text-amber-500 hover:text-amber-300 text-xs px-3 py-2 rounded-xl transition-colors"
          >
            {t.adsblock.cancel}
          </button>
        </div>
      </div>
    </div>
  );
}